import { render, staticRenderFns } from "./EmployeeView.vue?vue&type=template&id=120579e0&scoped=true&"
import script from "./EmployeeView.vue?vue&type=script&lang=js&"
export * from "./EmployeeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120579e0",
  null
  
)

export default component.exports